import { render } from "./PurchaseSecondaryTitle.vue?vue&type=template&id=77843b93"
const script = {}
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "77843b93"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('77843b93', script)) {
    api.reload('77843b93', script)
  }
  
  module.hot.accept("./PurchaseSecondaryTitle.vue?vue&type=template&id=77843b93", () => {
    api.rerender('77843b93', render)
  })

}

script.__file = "src/views/services/pageTitles/PurchaseSecondaryTitle.vue"

export default script